import { Shopify } from './shopify-format-money.js';

(() => {
  if (typeof window.customElements.get('wholesale-price-meta') !== 'undefined') { return }
  window.customElements.define('wholesale-price-meta',
    class ProductPrice extends HTMLElement {
      static get observedAttributes () { return ['data-handle'] }

      constructor () {
        super()

        // Variables
        this.handle = this.getAttribute('data-handle')
        this.variantID = this.getAttribute('data-variant')
        this.price = this.getAttribute('data-price')
        this.msrpPrice = null

        // Elements
        this.priceEl = this.querySelector('[data-price]')
        this.msrpEl = this.querySelector('[data-msrp-price]')
        this.profitEl = this.querySelector('[data-wholesale-profit]')

        if (this.handle) {
          this.getProductData()
        }
      }

      attributeChangedCallback (name, oldValue, newValue) {
        if (name === 'data-handle') {
          this.handle = newValue
          this.getProductData()
        }
      }

      async getProductData () {
        if (this.handle === '[[itemHandle]]') { return }

        const productData = await window.msrpClass.getMsrpProductData(this.handle)

        if (this.variantID !== '[[itemVariantID]]') {
          const variantID = parseInt(this.variantID, 10)
          const variantMsrpPrice = productData.msrp?.variants.find(variant => 
            variant.id === variantID
          )?.price
          
          this.msrpPrice = variantMsrpPrice || null
        } else {
          this.msrpPrice = productData.msrp?.price || null
        }

        this.updatePrices()
      }

      set price (price) {
        this._price = price
      }

      get price () {
        return this._price
      }

      set msrpPrice (price) {
        this._msrpPrice = price
      }

      get msrpPrice () {
        return this._msrpPrice
      }

      updatePrices () {
        if (this.msrpPrice) {
          const profit = this.msrpPrice - this.price

          this.priceEl.textContent = this.price ? Shopify.formatMoney(this.price, window.themeVariables.settings.moneyFormat) : '--'
          this.msrpEl.textContent = this.msrpPrice ? Shopify.formatMoney(this.msrpPrice, window.themeVariables.settings.moneyFormat) : '--'
          this.profitEl.textContent = Shopify.formatMoney(profit, window.themeVariables.settings.moneyFormat)
        } else {
          this.classList.add('price-list-wholesale--no-msrp')
        }
      }
    }
  )
})()
